import { render, staticRenderFns } from "./BasicHeader.vue?vue&type=template&id=fa000e40&scoped=true"
import script from "./BasicHeader.vue?vue&type=script&lang=ts"
export * from "./BasicHeader.vue?vue&type=script&lang=ts"
import style0 from "./BasicHeader.vue?vue&type=style&index=0&id=fa000e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa000e40",
  null
  
)

export default component.exports